import React from "react";
import './RecentVacancyDetails.css'
import Navbar from "../../../../components/navbar/Navbar";
import Footer from "../../../../components/footer/Footer";
import { BASE_URL, recentvacancyApi } from "../../../../api/api";
import SocialMediaPanel from "../../../../components/common/social-media/SocialMediaPanel";

const RecentVacancyDetails = () => {
    return (
        <>
            
 
            <div className="vacancy-details-contaner">

            </div>
            
        </>
    )
}

export default RecentVacancyDetails;